var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.73 9.626l-.55-.524a.94.94 0 00-.652-.256c-.247 0-.5.091-.672.256L8.29 12.47V1.77A.863.863 0 007.41.893h-.78c-.508 0-.972.393-.972.875v10.74L2.1 9.102a.909.909 0 00-.638-.256.924.924 0 00-.645.256l-.549.524a.846.846 0 00.002 1.238l6.077 5.774a.943.943 0 00.654.256h.002a.94.94 0 00.652-.256l6.076-5.774a.845.845 0 000-1.238z",
    fill: "#389E0D"
  })));
}

export default __webpack_public_path__ + "./fonts/arrow_down.7606bcf1c818319489174b7fe8e17395.svg";
export { SvgArrowDown as ReactComponent };